import excel from 'vue-excel-export'

export default {
    install(Vue, options) {

        const optionsDefaults = {}

        // Merge options argument into options defaults
        options = {
            ...optionsDefaults,
            ...options
        }

        Vue.use(excel, options)

    }
}
